<template>
  <v-runtime-template
    :template="t(props.templateT, props.templateProps)"
    :template-props="props.templateProps"
  ></v-runtime-template>
</template>

<script setup>
import VRuntimeTemplate from "vue3-runtime-template";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const props = defineProps({
  templateT: {
    type: String,
    required: true,
  },
  templateProps: {
    type: Object,
    default: () => ({}),
  },
});
</script>
